import { GlobalSpinner } from '@packages/common/components/GlobalSpinner/GlobalSpinner';
import { type FC, type PropsWithChildren, useEffect } from 'react';

import clsx from '@packages/clsx';
import { createPortal } from 'react-dom';
import styles from './Loader.module.scss';

export const SuspenseLoaderWrapper: FC<PropsWithChildren> = (props) => {
	return (
		<>
			{createPortal(
				<div className={clsx(styles.loader)}>
					<GlobalSpinner size={'l'} />
				</div>,
				document.body,
			)}
			{props.children}
		</>
	);
};

export const SuspenseLoader: FC = () => {
	useEffect(() => {
		setIsSuspenseLoading(true);
		return () => {
			setIsSuspenseLoading(false);
		};
	}, []);
	return null;
};

function setIsSuspenseLoading(isLoading: boolean) {
	document.documentElement.setAttribute(
		'suspense-page-is-loading',
		String(isLoading),
	);
}
